import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyName = microserviceNames.stakeholderMicroserviceWithoutToken;

export async function getStakeholderByIdOrVoen(body) {
  if (body?.pin) {
    return (
      await Axios.get(
        `${proxyName}/${Urls.Stakeholder}/identity?pin=${body.pin}`
      )
    ).data;
  }
  return (
    await Axios.get(
      `${proxyName}/${Urls.Stakeholder}/identity?voen=${body.voen}&id=${body.id}&pin=${body.pin}`
    )
  ).data;
}

export async function getStakeholderByPinAndVoen(body) {
  return (
    await Axios.get(`${proxyName}/${Urls.Stakeholder}/${body.pin}/${body.voen}`)
  ).data;
}

export async function getAllStakeholdersByPin(pin, voen) {
  return (await Axios.get(`${proxyName}/${Urls.Stakeholder}/${pin}/${voen}`))
    .data;
}

export async function getRegisteredStakeholdersWithoutVoen(pin) {
  return (await Axios.get(`${proxyName}/${Urls.Stakeholder}/${pin}`)).data;
}

export async function updateStakeholder(id, body) {
  return (await Axios.put(`${proxyName}/${Urls.Stakeholder}/${id}`, body)).data;
}

export async function getAllGrades() {
  return (await Axios.get(`${proxyName}/grade/getAll`)).data;
}
